import { render, staticRenderFns } from "./ModalMaterialsRequestTransfer.vue?vue&type=template&id=00172b93"
import script from "./ModalMaterialsRequestTransfer.vue?vue&type=script&lang=js"
export * from "./ModalMaterialsRequestTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports